import { render, staticRenderFns } from "./RobotForm.vue?vue&type=template&id=61b838dc"
import script from "./RobotForm.vue?vue&type=script&lang=js"
export * from "./RobotForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports